'use strict';

export default function (companyMember) {
  if (companyMember === 'admin') {
    return '主帐号';
  } else if (companyMember === 'member') {
    return '子帐号';
  } else {
    return '';
  }

}



// WEBPACK FOOTER //
// ./src/common/filters/company-role.js